export default {
  groupedHistories: state => {
    return state.groupedHistories
  },
  vesselName: state => {
    return state.vesselDetail.name_ja || state.vesselDetail.name || "UNKNOWN";
  },
  reportSender: state => {
    return state.sender
  },
}
